import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    // Meta Pixel Code
    const pixelId = '1904779843432668';
    // Initialize fbq
    if (typeof window !== 'undefined') {
      // @ts-ignore
      if (!window.fbq) {
        // @ts-ignore
        const fbq = function () {
          // @ts-ignore
          fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
        };
        // @ts-ignore
        if (!window._fbq) window._fbq = fbq;
        // @ts-ignore
        fbq.push = fbq;
        // @ts-ignore
        fbq.loaded = true;
        // @ts-ignore
        fbq.version = '2.0';
        // @ts-ignore
        fbq.queue = [];
        // @ts-ignore
        window.fbq = fbq;
        // Load the pixel script
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        // Try to insert before first script, otherwise append to head
        const firstScript = document.getElementsByTagName('script')[0];
        if (firstScript && firstScript.parentNode) {
          firstScript.parentNode.insertBefore(script, firstScript);
        } else {
          document.head.appendChild(script);
        }
      }
      // Initialize pixel and track PageView
      // @ts-ignore
      window.fbq('init', pixelId);
      // @ts-ignore
      window.fbq('track', 'PageView');
    }
  }, []);
  return <noscript data-id="element-176">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=1904779843432668&ev=PageView&noscript=1`} alt="" data-id="element-177" />
    </noscript>;
}